import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'reducers';
import { useHistory, Link, useLocation } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import {
	ArrowLeft,
	ProfileIcon,
	LockIcon,
	LogoutIcon,
	LogoutGray,
	UserIcon
} from 'assets/icons';
import { Logo, WhiteImage } from 'assets/img';

interface Props {
	className?: string
}

const logout = (dispatch: any, history: any) => {
	Globals.confirm('¿Desea cerrar sesión?', () => {
		dispatch({
			type: 'SET_USER',
			payload: null
		});
		history.replace('/login');
		Globals.quitLoading();
	});
}

const Header = (props: Props) => {
	const header = useSelector((state: RootState) => state.header);
	const subheader = useSelector((state: RootState) => state.subheader);
	const user = useSelector((state: RootState) => state.user);
	const [open, setOpen] = useState(false);
	const history = useHistory();
	const dispatch = useDispatch();
	const location = useLocation();

	// Validamos el nivel del usuario para determinar la ruta correcta
	const profilePath = user?.level_id === 4 ? '/affiliate-profile' : '/profile';

	return (
		<div id="header" className={props.className}>
			<div className="container-blue-top">
				<div className="container-logo">
					<Link to="/">
						<img src={Logo} alt="Logo" />
					</Link>
				</div>
				<div className="container-back-top">
					{
						header.onBack && (
							<div className="arrow-back" onClick={header.onBack}>
								<img src={ArrowLeft} alt="Volver" />
							</div>
						)
					}
					<div className="container-titles">
						<h3 className="title-top">{header.title}</h3>
						<h4 className="subtitle-top">{subheader.title}</h4>
					</div>
				</div>
				<div className="container-buttons-top">
					<button className="focusable-container" onBlur={() => setOpen(false)}>
						{
							user && (
								<div className="container-user" onClick={() => setOpen(!open)}>
									<img className="avatar-image" src={UserIcon} alt="Usuario" />
									<p>{user?.name}</p>
									<i className="fa fa-caret-down"></i>
								</div>
							)
						}
						{
							open && (
								<ul>
									{/* Reemplazamos la ruta estática por la variable profilePath */}
									<li onClick={() => { setOpen(false); history.replace(profilePath) }}>
										<img src={ProfileIcon} alt="Mis Datos" />
										Mis Datos
									</li>
									<li onClick={() => { setOpen(false); logout(dispatch, history) }}>
										<img src={LogoutGray} alt="Salir" />
										Salir
									</li>
								</ul>
							)
						}
					</button>
					<div className="container-buttons-web">
						<Link to={profilePath}>
							<button className={`btn-profile ${location.pathname === profilePath ? 'active' : ''}`}>
								<img className="avatar-image" src={user?.photo ? (Constants.BASE_STORAGE + user?.photo) : WhiteImage} alt="Avatar" />
								{user?.name}
							</button>
						</Link>
						<button className="btn-logout" onClick={() => logout(dispatch, history)}>
							Salir
							<img src={LogoutIcon} alt="Salir" />
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Header;